export function getPlaceOdds(winOdds, eachWayTerms) {
  if (!winOdds || !eachWayTerms || eachWayTerms <= 1) {
    return 0; // Handle invalid inputs like 0 or negative values
  }
  return 1 + ((winOdds - 1) / (1 / (eachWayTerms - 1)));
}
